import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from 'src/app/shared/toast/toast.service';
import { ReservationsService, SlotReservationSettings, SlotReservation } from '../reservations.service';
import moment from 'moment';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { FormBuilder, FormGroup, Validators, NgForm } from '@angular/forms';
import { ScheduleTime } from 'src/app/shared/models/schedule-time.model';
import { Schedule } from 'src/app/shared/models/schedule.model';

@Component({
    selector: 'app-slot-reservations',
    templateUrl: './slot-reservations.component.html',
    styleUrls: ['./slot-reservations.component.css'],
    standalone: false
})
export class SlotReservationsComponent implements OnInit {


  @ViewChild('settingsForm') form: NgForm;
  @Input() settings: SlotReservationSettings;

  public orgId: string;
  public reservations: SlotReservation[] = [];
  public formGroup: FormGroup;
  public icons: { [name: string]: any } = {
    'faCalendarAlt': faCalendarAlt
  };

  constructor(private _reservationsService: ReservationsService, private _activatedRoute: ActivatedRoute,
    private _toastService: ToastService, private _formBuilder: FormBuilder) {
    this.formGroup = this._formBuilder.group({
      id: [''],
      startHour: ['', <any>Validators.required],
      endHour: ['', <any>Validators.required],
      breakStartHour: [''],
      breakEndHour: [''],
      mondaySlot: [''],
      tuesdaySlot: [''],
      wednesdaySlot: [''],
      thursdaySlot: [''],
      fridaySlot: [''],
      saturdaySlot: [''],
      sundaySlot: [''],
      mondayAllowedPerson: [''],
      tuesdayAllowedPerson: [''],
      wednesdayAllowedPerson: [''],
      thursdayAllowedPerson: [''],
      fridayAllowedPerson: [''],
      saturdayAllowedPerson: [''],
      sundayAllowedPerson: [''],
      expireAfter: ['', <any>Validators.required],
      startPeriod: ['', <any>Validators.required],
      endPeriod: ['', <any>Validators.required],
      organizationId: ['']
    });

    this._toastService.remove();
  }

  ngOnInit(): void {
    const routeParams = this._activatedRoute.snapshot.params;
    this.orgId = routeParams.orgId;
    this._reservationsService.getSlotReservations(this.orgId, moment().format('yyyy-MM-DD')).subscribe(result => {
      console.log(result);
      this.reservations = result;
    });

    this._reservationsService.approveSlotReservationSubject.subscribe(index => {
      const selectedReservation = { ...this.reservations[index] };
      this._reservationsService.approveSlotReservation(selectedReservation.reservationCode).subscribe(result => {
        this.reservations[index].status = result.status;
      });
    });

    this.formGroup.patchValue(this.settings);
    this.formGroup.patchValue({ startHour: ScheduleTime.convertStringToObject(this.settings.startHour) });
    this.formGroup.patchValue({ endHour: ScheduleTime.convertStringToObject(this.settings.endHour) });
    this.formGroup.patchValue({ startPeriod: Schedule.convertDateToNgbDataStructure(this.settings.startPeriod) });
    this.formGroup.patchValue({ endPeriod: Schedule.convertDateToNgbDataStructure(this.settings.endPeriod) });
  }

  onSettingsSubmit() {
    if (this.form.valid) {
      const value = this.form.value;
      value.startPeriod = Schedule.convertNgbDataStructureToDateString(value.startPeriod);
      value.endPeriod = Schedule.convertNgbDataStructureToDateString(value.endPeriod);
      value.startHour = ScheduleTime.convertObjectToTimeString(value.startHour);
      value.endHour = ScheduleTime.convertObjectToTimeString(value.endHour);
      value.mondaySlot = this.settings.mondaySlot;
      value.tuesdaySlot = this.settings.tuesdaySlot;
      value.wednesdaySlot = this.settings.wednesdaySlot;
      value.thursdaySlot = this.settings.thursdaySlot;
      value.fridaySlot = this.settings.fridaySlot;
      value.saturdaySlot = this.settings.saturdaySlot;
      value.sundaySlot = this.settings.sundaySlot;
      value.mondayAllowedPerson = this.settings.mondayAllowedPerson;
      value.tuesdayAllowedPerson = this.settings.tuesdayAllowedPerson;
      value.wednesdayAllowedPerson = this.settings.wednesdayAllowedPerson;
      value.thursdayAllowedPerson = this.settings.thursdayAllowedPerson;
      value.fridayAllowedPerson = this.settings.wednesdayAllowedPerson;
      value.saturdayAllowedPerson = this.settings.saturdayAllowedPerson;
      value.sundayAllowedPerson = this.settings.sundayAllowedPerson;
      value.organizationId = this.orgId;
      this._reservationsService.updateSlotReservationSettings(value).subscribe(result => {
        this._toastService.show('', {
          classname: 'bg-success text-light',
          delay: 2000,
          autohide: true,
        });
      });
    } else {
      console.log('error');
    }
  }

}
